import { render, staticRenderFns } from "./SentList.vue?vue&type=template&id=d1e4632a&"
import script from "./SentList.vue?vue&type=script&lang=js&"
export * from "./SentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports